module.exports = {
  key: "authentication",

  authentication: {
    components: {
      auth: {
        welcome: "Welcome back",
        title: "Login to your account",
        buttons: {
          submit: "Submit",
          login: "Login now",
        },
      },
      register: {
        title: "Register",
        buttons: {
          submit: "Submit",
        },
      }
    },
    router_title: {
      login: "Login",
      register: "Register",
      forget_password: "Forget Password",
      contact_us: "Contact us",
    },
  },
  attribute: {
    userName: "Username",
    password: "Password",
    fullName: "Full name",
    nickName: "Nick name",
    permissions: "Permissions",
    additionalPermissions: "Additional permissions",
    confirm_password: "Confirm Password",
  },
  placeholder: {},
};
